import * as React from 'react';
import { BaSeHeading1, BaSeHeading3 } from '@base/react';
import './styles.scss';

export const Title = ({
  titulo,
  subtitulo,
  paddingContent,
  paddingSubtitulo,
}) => {
  return (
    <div className="titulo" style={{ padding: `${paddingContent} 0` }}>
      <BaSeHeading1 color="#0f438a">{titulo}</BaSeHeading1>
      <BaSeHeading3
        color="#0f438a"
        style={{ paddingTop: `${paddingSubtitulo}` }}
      >
        {subtitulo}
      </BaSeHeading3>
    </div>
  );
};
